import React, { useState, useEffect } from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';
// import { HiStatusOnline } from "react-icons/hi";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import { FaCrown } from 'react-icons/fa';
import axios from 'axios';
import key from '../../key';
import { dobToAge } from '../../utilities/utilities';
import { useSelector } from 'react-redux';
import { Link,useNavigate } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { addLikes } from '../../Redux/features/User/userSlice';
import { BsShieldFillCheck, BsChatHeart } from "react-icons/bs";
import MatchContact from './MatchContact';

function MatchCardIgnored({ match }) {
    const [loading, setLoading] = useState(true)
    const [showPhoto, setShowPhoto] = useState("show")
    const [showBadge, setShowBadge] = useState(false)
    const [db, setDb] = useState()
    const [data, setData] = useState()
    const { user } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [isConnected, setIsConnected] = useState()
    const navigate = useNavigate()
    //eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios(`${key}/api/user/get-profile/${match.userId}`, {
                headers: {
                    "x-auth-token": cookies['x-auth-token'],
                },
            });
            setIsConnected(result.data.isConnected)
            setData(result.data.user);

            if (result.data.user?.privacy.photo === "hide") {
                setShowPhoto("hide")
            } else if (result.data.user?.privacy.photo === "like" && !isConnected) {
                setShowPhoto("like")
            } else if (result.data.user?.privacy.photo === "premium" && user.userStatus.membership.membershipType === "Free") {
                setShowPhoto("premium")
            } else if (result.data.user?.privacy.photo === "likeAndPremium" && ((user.userStatus.membership.membershipType === "Free") || isConnected)) {
                setShowPhoto("premium")
            } else if (result.data.user?.privacy.photo === "likeAndPremium" && ((user.userStatus.membership.membershipType !== "Free") || !isConnected)) {
                setShowPhoto("like")
            }

        };
        fetchData();
        //eslint-disable-next-line
    }, []);

    setTimeout(() => {
        const getAge = () => {
            if (data?.personalDetails?.dob) {
                setDb(dobToAge(data?.personalDetails?.dob))
            }
        }
        getAge()
        if (data?.userStatus?.membership?.membershipType !== "Free") {
            setShowBadge(true)
        }
        setLoading(false)
    }, 500)
    const handleConnect = async (id) => {
        setLoading(true)
        const data = {
            id: {
                userId: id
            },
            header: cookies['x-auth-token']
        }
        dispatch(addLikes(data))
        setIsConnected(true)
        setLoading(false)
    }
    return (
        <>
            {loading ? <div className="loading-spinner"><PulseLoader size={50} color="#fa585b" /></div> :
                <div className="list-match-card">
                    <div className="match-photo">
                        <div className="list-image-container">
                            {showPhoto === "premium" && <div className="image-overlay">
                                <Image onClick={()=>navigate(`/view-match/${match?.userId}`)} fluid={true} src={`${key}/images/${data?.photos[0]?.url}`} alt="photo" />
                                <Link to="/pricing-table" className='button'>Buy Premium to View Images</Link>
                            </div>}
                            {showPhoto === "like" && <div className="image-overlay">
                                <Image onClick={()=>navigate(`/view-match/${match?.userId}`)} fluid={true} src={`${key}/images/${data?.photos[0]?.url}`} alt="photo" />
                                <Link className='button'>You need to connect with this member to View Images</Link>
                            </div>}
                            {showPhoto === "hide" && <div className="image-overlay">
                                <Image onClick={()=>navigate(`/view-match/${match?.userId}`)} fluid={true} src={`${key}/images/${data?.photos[0]?.url}`} alt="photo" />
                                <Link className='button'>Photo is Hide by the Member itself</Link>
                            </div>}
                        </div>
                        {!showBadge &&
                            <div className="image-tag">Premium <FaCrown /></div>
                        }
                    </div>
                    <div className="list-match-info">
                        <div className="match-card-header mx-auto">
                            <div className="d-flex justify-content-around">
                                <Link to={`/view-match/${match?.userId}`} className="match-name">{data?.firstName} {data?.lastName} {data?.userStatus?.isVerified && <BsShieldFillCheck className='secondary' />} <span>{data?.userId}</span></Link>
                                {/* <Dropdown
                                menu={{ items: shortlistsubs }}>
                                <Link>
                                    <Space>
                                        <FiArrowDownCircle size={25} />
                                    </Space>
                                </Link>
                            </Dropdown> */}
                            </div>
                            {/* <div className='d-flex justify-content-center status'>
                            <div>{match?.userStatus?.isOnline ? <HiStatusOnline className='text-success' /> : <HiStatusOnline className='text-danger' />} {match?.userStatus?.isOnline ? 'Online Now' : 'Offline'}</div>
                        </div> */}
                        </div>
                        <Col lg={12} md={12} sm={12} className="match-info backgroundLight">
                            <div className="match-card-body text-center">
                                <Row className=''>
                                    <Col>
                                        {!loading && <div>{db} yrs, {data?.personalDetails?.height}</div>}
                                        <div>{data?.personalDetails?.religion}, {data?.personalDetails?.community}</div>
                                        <div>{data?.personalDetails?.motherTongue}</div>
                                    </Col>
                                    <Col className=''>
                                        <div>{data?.personalDetails?.maritalStatus}</div>
                                        <div>{data?.personalDetails?.cityLiving}, {data?.personalDetails?.countryLiving}</div>
                                        <div className='badge bg-success text-white fw-bold'>Looking for: {data?.lookingFor}</div>
                                    </Col>
                                </Row>
                                <div className='match-about'>{match?.personalDetails?.aboutMe}</div>
                            </div>
                        </Col>
                    </div>
                    <div className='d-flex custom-footer-card justify-content-center'>
                        {isConnected ? <div className='list-chat-button-container d-flex-justify-content-between'>
                            <Link className='chat-now-button'  to="/chat" ><BsChatHeart />Chat Now</Link>
                            <MatchContact match={data} isConnected={isConnected} />
                        </div>
                            :
                            <div className='list-connect-button-container d-flex-justify-content-between'>
                                <button className='connect-now-button' onClick={() => handleConnect(data?._id)}><FaRegCheckCircle />Connect Now</button>
                                <MatchContact match={data} isConnected={isConnected} />
                            </div>}
                    </div>
                </div>
            }
        </>
    );
}

export default MatchCardIgnored;
